import React from "react";
import { Link } from "react-router-dom";

class Footer extends React.Component {


    render() {
        return (
            <footer>
                <div className="wrapper">
                    <div className="button-lines"><Link to="/" className="button">Back to Menu</Link></div>
                    <div className="footer-nav"><button onClick={this.props.togglePopout}>About the Authors and Acknowledgements</button></div>
                    <div className="footer-bottom">
                        <div className="row">
                            <div className="copy col-sm-6">&copy; Peapack-Gladstone Bank 2020</div>
                            <div className="cc col-sm-6">Design by <a href="https://www.curran-connors.com/" target="_blank" rel="noopener noreferrer">Curran &amp; Connors</a></div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;